import Cookie from 'js-cookie';
import { req } from 'react-reqq-lite';

import { toastSuccess } from 'modules/common/toast';
import { formatGetQueryParams } from 'modules/common/utils';
import {
  initApp,
  initMessaging,
  initAuth,
} from 'modules/common/firebase/hooks';

import * as c from './constants';
import * as t from './transformers';

const partnerOnSuccess = (res, callback) => {
  const {
    response: {
      token,
      fb_token,
      user_type,
      show_tutorial,
      tutorial_step,
      subscription,
      method,
      message,
      user_uuid,
      receiver_end,
      receiver_start,
    },
  } = res || {};

  if (Object.hasOwn(res?.response, 'method')) {
    callback({
      method,
      message,
      user_uuid,
      receiver_end,
      receiver_start,
    });
    return;
  }

  const type =
    {
      partner: 'PARTNER',
    }[user_type] || 'PARTNER';
  Cookie.set('_token', token);
  Cookie.set('_fbToken', fb_token);
  Cookie.set('_userType', type);

  Cookie.set('_tutorial_step', tutorial_step);
  Cookie.set('_show_tutorial', show_tutorial);

  if (type === 'MERCHANT' && subscription) {
    Cookie.set('_subscription', subscription);
  }

  req.set(c.AUTHENTICATION, {
    isAuthenticated: true,
    type,
  });

  callback();
};

const adminOnSuccess = (res, callback) => {
  const {
    response: {
      token,
      // fb_token,
      message,
      method,
      user_uuid,
      receiver_end,
      receiver_start,
    },
  } = res || {};

  if (Object.hasOwn(res?.response, 'method')) {
    callback({
      method,
      message,
      user_uuid,
      receiver_end,
      receiver_start,
    });
    return;
  }

  const type = 'ADMIN';
  Cookie.set('_token', token);
  // Cookie.set('_fbToken', fb_token);
  Cookie.set('_userType', type);
  req.set(c.AUTHENTICATION, {
    isAuthenticated: true,
    type,
  });
  callback();
};

const vendorOnSuccess = (res, callback) => {
  const {
    response: {
      token,
      fb_token,
      user_type,
      show_tutorial,
      tutorial_step,
      subscription,
      method,
      message,
      user_uuid,
      receiver_end,
      receiver_start,
    },
  } = res || {};

  if (Object.hasOwn(res?.response, 'method')) {
    callback({
      method,
      message,
      user_uuid,
      receiver_end,
      receiver_start,
    });
    return;
  }

  const type =
    {
      branch_user: 'BRANCH',
      vendor: 'MERCHANT',
    }[user_type] || 'MERCHANT';
  Cookie.set('_token', token);
  Cookie.set('_fbToken', fb_token);
  Cookie.set('_userType', type);

  Cookie.set('_tutorial_step', tutorial_step);
  Cookie.set('_show_tutorial', show_tutorial);

  if (type === 'MERCHANT' && subscription) {
    Cookie.set('_subscription', subscription);
  }

  req.set(c.AUTHENTICATION, {
    isAuthenticated: true,
    type,
  });

  callback();

  try {
    const fb = initApp();
    initAuth(fb);
    const messagingResponse = initMessaging(fb);

    messagingResponse?.then(($token) => {
      if (!$token) return;

      req.post({
        key: c.LOGIN,
        url: '/set-fcm-token',
        payload: { token: $token },
        headers: (headers) => ({
          ...headers,
          Authorization: `Bearer ${token}`,
        }),
      });
    });
  } catch (err) {
    // eslint-disable-next-line
    console.log(err);
  }
};

export const adminLogin = (payload, callback = () => {}, ecb = () => {}) => {
  req.post({
    key: c.LOGIN,
    url: '/v1/auth',
    payload,
    onSuccess: (res) => adminOnSuccess(res, callback),
    onError: (err) => {
      ecb(err?.response);
    },
  });
};

export const vendorSignUp = (payload, callback = () => {}) => {
  req.post({
    key: c.SIGN_UP,
    url: '/v2/vendors/register',
    payload,
    onSuccess: () => {
      toastSuccess('Sign up complete! Please check your email address.');
      callback();
    },
  });
};

export const vendorLogin = (payload, callback = () => {}, ecb = () => {}) => {
  req.post({
    key: c.LOGIN,
    url: '/v1/vendor/auth',
    payload,
    onSuccess: (res) => vendorOnSuccess(res, callback),
    onError: (err) => {
      ecb(err?.response);
    },
  });
};

export const partnerLogin = (payload, callback = () => {}, ecb = () => {}) => {
  req.post({
    key: c.LOGIN,
    url: '/v1/partner/auth',
    payload,
    onSuccess: (res) => partnerOnSuccess(res, callback),
    onError: (err) => {
      ecb(err?.response);
    },
  });
};

export const locationLogin = (payload, callback = () => {}) => {
  req.post({
    key: c.LOGIN,
    url: '/v1/location/auth',
    payload,
    onSuccess: ({
      response: {
        token,
        // fb_token,
        show_tutorial,
        tutorial_step,
      },
    }) => {
      const type = 'LOCATION';

      Cookie.set('_token', token);
      // Cookie.set('_fbToken', fb_token);
      Cookie.set('_userType', type);
      Cookie.set('_tutorial_step', tutorial_step);
      Cookie.set('_show_tutorial', show_tutorial);

      req.set(c.AUTHENTICATION, {
        isAuthenticated: true,
        type,
      });
      callback();
    },
  });
};

export const logout = () => {
  Cookie.remove('_token');
  Cookie.remove('_userType');
  Cookie.remove('_fbToken');
  Cookie.remove('_subscription');
  Cookie.remove('_show_tutorial');
  Cookie.remove('_tutorial_step');
  req.cancelAll();
  req.reset();
  req.set(c.AUTHENTICATION, {
    isAuthenticated: false,
  });
};

export const postForgotPassword = (payload, onSuccess) => {
  req.post({
    key: c.FORGOT_PASSWORD,
    url: '/v1/vendor/forgot-password',
    payload,
    onSuccess: (res) => {
      toastSuccess(res?.response?.message || 'Email sent successfully!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
  });
};

export const updatePassword = (payload, cb) => {
  req.post({
    key: c.UPDATE_PASSWORD,
    url: '/v1/me/change-password',
    payload,
    onSuccess: (res) => {
      toastSuccess(res?.response?.message || 'Password updated successfully!');
      cb();
    },
  });
};

export const postResetPassword = (payload, token, cb, ecb) => {
  req.post({
    key: c.RESET_PASSWORD,
    url: '/v2/vendor/reset-password',
    headers: (headers) => ({
      ...headers,
      Authorization: `Bearer ${token}`,
    }),
    payload,
    onSuccess: (res) => {
      toastSuccess(res?.response?.message || 'Password updated successfully!');
      cb?.(res);
    },
    onError: (err) => ecb?.(err),
  });
};

export const getTokenExpiry = (token, cb, ecb) => {
  req.get({
    key: c.TOKEN_EXPIRY,
    url: '/v2/forgot-password/otp-checker',
    headers: (headers) => ({
      ...headers,
      Authorization: `Bearer ${token}`,
    }),
    onSuccess: (res) => cb?.(res),
    onError: (err) => ecb?.(err),
  });
};

export const getNotification = ({ params } = {}, cb) => {
  req.get({
    url: '/v1/notifications',
    key: c.GET_NOTIFICATION,
    params: formatGetQueryParams(params, true),
    transform: ({ data, meta }) => ({
      data: data?.map(t.transformGetNotification),
      pagination: meta?.pagination,
    }),
    onSuccess: (res) => {
      if (typeof cb === 'function') cb?.(res);
    },
  });
};

export const getAppendNotification = ({ params } = {}, cb) => {
  req.get({
    url: '/v1/notifications',
    key: c.GET_NOTIFICATION_APPEND,
    params: formatGetQueryParams(params, true),
    transform: ({ data, meta }) => ({
      data: data?.map(t.transformGetNotification),
      pagination: meta?.pagination,
    }),
    onSuccess: (res, state) => {
      req.set(c.GET_NOTIFICATION, {
        ...(state[c.GET_NOTIFICATION] || {}),
        data: (state[c.GET_NOTIFICATION]?.data || []).concat(
          (res?.response?.data || []).map(t.transformGetNotification)
        ),
      });
      cb?.(res);
    },
  });
};

export const patchNotification = ({ params, payload, id } = {}, cb) => {
  req.patch({
    url: `/v1/notifications/${id}/read`,
    key: c.PATCH_NOTIFICATION,
    params,
    payload,
    onSuccess: (res) => cb?.(res),
  });
};

export const getNewNotification = ({ params } = {}, cb) => {
  req.get({
    url: '/v1/notifications',
    key: c.GET_NEW_NOTIFICATION,
    params: formatGetQueryParams(params, true),
    transform: ({ data, meta }) => ({
      data: data?.map(t.transformGetNotification),
      pagination: meta?.pagination,
      total_new: meta?.pagination?.total,
    }),
    onSuccess: (res) => cb?.(res),
  });
};

export const postMarkAllAsRead = ({ payload } = {}, cb) => {
  req.post({
    key: c.POST_MARK_ALL_AS_READ,
    url: '/v1/notifications/read-all',
    payload,
    onSuccess: (res) => {
      cb?.(res);
    },
  });
};

export const passwordExpired = ({ payload, token } = {}, cb) => {
  req.post({
    key: c.PASSWORD_EXPIRED,
    url: '/v2/change-password',
    payload,
    onSuccess: (res) => {
      toastSuccess('Password updated successfully.');
      cb?.(res);
    },
    headers: (headers) => ({
      ...headers,
      Authorization: `Bearer ${token}`,
    }),
  });
};

export const selectAuthMethod = ({ payload, userType = 'vendor' } = {}, cb) => {
  req.post({
    key: c.SELECT_AUTH_METHOD,
    url: `/v1/${userType}/auth/method`,
    payload,
    onSuccess: (res) => {
      toastSuccess('OTP sent successfully.');
      if (typeof cb === 'function') cb(res);
    },
  });
};

export const authOtp = (
  { payload, userType } = {},
  cb = () => {},
  ecb = () => {}
) => {
  req.post({
    key: c.AUTH_OTP,
    url: `/v1/${userType}/auth/validate`,
    payload,
    onSuccess: (res) => {
      const renderDispatch = {
        admin: adminOnSuccess,
        vendor: vendorOnSuccess,
        partner: partnerOnSuccess,
      }?.[userType];

      renderDispatch(res, cb);
    },
    onError: (err) => {
      ecb(err?.response);
    },
  });
};
